module.exports = __webpack_public_path__ + "static/media/vid.7fd1ad17.m4v";